import { Pipe, PipeTransform } from "@angular/core";
import { DateTime } from 'luxon';

@Pipe({
    name: 'humandate',
    standalone: true
})
export class HumanDatePipe implements PipeTransform {
    transform(src: string | Date | null | undefined): string {
        if (!src) return '';
        if (src instanceof Date) {
            return DateTime.fromJSDate(src).toFormat('ff');
        }
        const dt = DateTime.fromISO(src);
        return dt.toFormat('ff');
    }
}
